"use strict";
exports.__esModule = true;
exports.RateHelper = exports.VAT_EXCLUDED_MESSAGE = exports.VAT_INCLUDED_MESSAGE = void 0;
var rate_model_1 = require("./rate.model");
var money_1 = require("../../../core/money");
var model_1 = require("../../room/model");
var core_1 = require("../../../core");
exports.VAT_INCLUDED_MESSAGE = core_1.Language.getTranslation('vatIncluded');
exports.VAT_EXCLUDED_MESSAGE = core_1.Language.getTranslation('vatExcluded');
var getDatePartOfRateId = function (stayPeriod) {
    var arrivalDate = stayPeriod.arrivalDate.replace(/-/g, '');
    var departureDate = stayPeriod.departureDate.replace(/-/g, '');
    return arrivalDate + ";" + departureDate;
};
var getIdPartOfRateId = function (rateId) {
    var partsOfRateId = rateId.split(';');
    return partsOfRateId[partsOfRateId.length - 1];
};
var getOnSiteTaxesMessageFormatted = function (rate) {
    var onSiteTaxesDetail = rate.taxes.onSite.details[0];
    return (onSiteTaxesDetail ? onSiteTaxesDetail.name + ": " + onSiteTaxesDetail.description + " (" + onSiteTaxesDetail.amount.converted.text + ")" : '');
};
var multiplyMoney = function (money, times) {
    var value = money.value;
    var multiplied = value.amount * times;
    var isInteger = multiplied % 1 === 0;
    var decimal = isInteger ? 0 : 2;
    return (money_1.MONEY_SYMBOLS[value.currency] || value.currency) + " " + multiplied.toFixed(decimal);
};
var sumMoney = function (moneys, currency) {
    var sum = moneys.reduce(function (acc, money) {
        return acc + money.value.amount;
    }, 0);
    var isInteger = sum % 1 === 0;
    var decimal = isInteger ? 0 : 2;
    return (money_1.MONEY_SYMBOLS[currency] || currency) + " " + sum.toFixed(decimal);
};
var getTaxesMessageFormatted = function (taxes) {
    if (taxes.excluded.amount.value.amount === 0) {
        return exports.VAT_INCLUDED_MESSAGE;
    }
    return exports.VAT_EXCLUDED_MESSAGE;
};
var getDefaultCancelConditionMessage = function (rate) {
    var cancelCondition = rate.description.cancelConditions.summary.find(function (summary) { return summary.value === rate_model_1.CancelConditionType.Default; });
    return cancelCondition && cancelCondition.text;
};
var getDefaultCancelConditionName = function (rate) {
    var cancelCondition = rate.description.cancelConditions.name.find(function (name) { return name.value === rate_model_1.CancelConditionType.Default; });
    return cancelCondition && cancelCondition.text;
};
var getCoverImage = function (rate) {
    if (rate.description.pictures.length) {
        return rate.description.pictures[0].templates.find(function (t) { return t.name === model_1.RoomTemplateImage.Original; });
    }
    return {};
};
var getSummaryType = function (summary, type) {
    return summary.find(function (s) { return s.value === type; });
};
var getCheapestRate = function (rates) {
    if (!rates) {
        return {};
    }
    var indexOfMin = 0;
    for (var i = 1; i < rates.length; i++) {
        var amountToCompare = function (index) { return rates[index].price.totalPrice.original.value.amount; };
        if (amountToCompare(indexOfMin) > amountToCompare(i)) {
            indexOfMin = i;
        }
    }
    return rates[indexOfMin];
};
exports.RateHelper = {
    getDatePartOfRateId: getDatePartOfRateId,
    getIdPartOfRateId: getIdPartOfRateId,
    multiplyMoney: multiplyMoney,
    sumMoney: sumMoney,
    getOnSiteTaxesMessageFormatted: getOnSiteTaxesMessageFormatted,
    getTaxesMessageFormatted: getTaxesMessageFormatted,
    getDefaultCancelConditionMessage: getDefaultCancelConditionMessage,
    getDefaultCancelConditionName: getDefaultCancelConditionName,
    getCoverImage: getCoverImage,
    getSummaryType: getSummaryType,
    getCheapestRate: getCheapestRate
};
//# sourceMappingURL=rate.helper.js.map